import { Placement } from '@floating-ui/core'
import cx from 'classnames'
import { EditorColorPicker } from 'common/Prose/components/EditorColorPicker/EditorColorPicker'
import { DEFAULT_QUOTE_COLOR, QUOTE_COLOR_OPTIONS } from 'common/Prose/constants/colorOptions'
import { useQuoteButton } from 'components/DocRightRail/screens/FormatMenu/hooks/useQuoteButton'
import { observer } from 'mobx-react-lite'
import Styles from './DoubleActionButtons.module.scss'
import { ChevronDown } from 'almanac-ui/icons/12'
import { useHover } from '@react-aria/interactions'
import { SimpleDropdown } from '../SimpleDropdown/SimpleDropdown'
import { IconButton } from 'components/IconButton/IconButton'

const Icon = ({ colorCount }: { colorCount?: number }) => {
  const { activeColors, active } = useQuoteButton()
  const activeQuoteColors = activeColors.slice(0, colorCount)
  const colorHeight = 100 / activeQuoteColors.length

  if (active) {
    return (
      <span className={Styles.quoteIcon}>
        {activeQuoteColors.map((color) => (
          <span key={`activeColorIndicator-${color}`} style={{ background: color, flexBasis: `${colorHeight}%` }} />
        ))}
      </span>
    )
  }
  return <span className={cx(Styles.quoteIcon, Styles.inactive)} />
}

export const QuoteButton = observer(function QuoteButton({
  colorCount = 4,
  dropdownPlacement = 'bottom',
}: {
  colorCount?: number
  dropdownPlacement?: Placement
}) {
  const { activeColors, active, disabled, setColor, removeColor } = useQuoteButton()
  const { hoverProps, isHovered } = useHover({})

  const onClick = () => {
    if (active) {
      removeColor()
    } else {
      setColor(DEFAULT_QUOTE_COLOR)
    }
  }

  return (
    <div className={cx(Styles.doubleActionButton, Styles.quoteButton)}>
      <IconButton
        variant="tertiary"
        size="md"
        onPress={onClick}
        aria-label="Add a quote with a colored left bar"
        className={cx(Styles.directActionButton, Styles.quoteButton, { [Styles.hovered]: isHovered })}
        icon={() => (
          <div className={cx(Styles.quoteIndicator, { [Styles.active]: active })}>
            <Icon colorCount={colorCount} /> Quote
          </div>
        )}
      />
      <SimpleDropdown
        buttonClassName={Styles.arrow}
        hasChevron={false}
        disabled={disabled}
        unStyledButton
        tooltip={{ label: 'Quote' }}
        placement={dropdownPlacement}
        {...hoverProps}
      >
        <ChevronDown />
        <EditorColorPicker
          aria-label={(color: string) => `Change quote color to ${color}`}
          colorOptions={QUOTE_COLOR_OPTIONS}
          activeColors={activeColors}
          setColor={setColor}
          removeColor={removeColor}
          defaultColor={DEFAULT_QUOTE_COLOR}
          noColorButtonPos="bottom"
          noColorButtonLabel="Remove"
          includeDropdownStyles={false}
        />
      </SimpleDropdown>
    </div>
  )
})
